import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const EraseStylesIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "EraseStyles",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M28.49 27.01H17.48l11.47-11.77a3.577 3.577 0 0 0 0-5.06l-7.12-7.11c-.65-.64-1.54-1.04-2.52-1.04s-1.88.4-2.52 1.04L3.05 16.43a3.577 3.577 0 0 0 0 5.06l7.42 7.42c.52.52 1.19.87 1.94.99h.02q.18.06.39.06h15.67c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5V27ZM18.9 5.19c.11-.11.25-.17.41-.17s.31.07.41.17l7.11 7.11c.11.11.17.26.17.42s-.07.31-.17.42l-6.24 6.36-8.12-8.05z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M27.86 29.01H13.31a1.14 1.14 0 1 1 0-2.28h14.55a1.14 1.14 0 1 1 0 2.28"
      }), /*#__PURE__*/_jsx("path", {
        d: "M13.4 29.01c-.92 0-1.78-.36-2.42-1l-6.12-6.12a3.43 3.43 0 0 1 0-4.85L17.04 4.86c1.3-1.29 3.55-1.29 4.85 0l6.12 6.12a3.43 3.43 0 0 1 0 4.85L15.83 28.01c-.65.65-1.51 1-2.42 1Zm6.06-22.87c-.31 0-.59.12-.81.33L6.47 18.65a1.14 1.14 0 0 0 0 1.62l6.12 6.12c.43.43 1.19.43 1.62 0l12.18-12.18c.45-.45.45-1.17 0-1.62l-6.12-6.12c-.22-.22-.5-.33-.81-.33"
      }), /*#__PURE__*/_jsx("path", {
        d: "M21.11 22.25c-.29 0-.58-.11-.81-.33l-9.35-9.35c-.45-.45-.45-1.17 0-1.62s1.17-.45 1.62 0l9.35 9.35a1.14 1.14 0 0 1-.81 1.95"
      })]
    })
  }));
};